<template>
	<div class="person">
		<img :src="currentPerson.picture" />
	</div>
</template>

<script>
export default {
	name: 'Person',
	props: ['currentPerson'],
};
</script>

<style lang="scss" scoped>
	.person{
		width: 100%;
		height: 100%;
		top: -1.5%;
		left: 0%;
		position: absolute;
		text-align: center;
		img{
			width: 100%;
			height: 100%;
		}
		p{
			position: absolute;
			top: 70%;
			left: 30%;
			color: white;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Person.vue